import { createApp } from 'vue'
import App from './App.vue'
import Boot from 'src/boot'
//
;(async () => {
  const app = createApp(App)
  await Boot(app)
  app.mount('#app')
})()
